import { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { assets } from "@/siteData";
import { useLanguage } from "@/i18n";
import LocaleSwitcher from "@/components/LocaleSwitcher";
import "@/Landing.css";
import "@/Tracking.css";
import "@/Routes.css";
import "@/RoutePages.css";
import "@/SharedRoutes.css";

const navItems = [
  ["home", "/"], ["about", "/about-us"], ["coverage", "/coverages"], ["gallery", "/gallery"], ["investor", "/investor"],
];

export default function SiteLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useLanguage();
  const closeMenu = () => setMenuOpen(false);
  return <main data-testid="sbf-website">
    <header className="topbar" data-testid="site-header">
      <div className="brand-area"><Link className="brand" to="/" onClick={closeMenu} data-testid="brand-home-link"><img src={assets.logo} alt="PT Samudera Berkah Firdaus" data-testid="company-logo" /></Link><LocaleSwitcher /></div>
      <nav className="nav" data-testid="desktop-navigation">
        {navItems.map(([label, href]) => <NavLink key={href} to={href} end={href === "/"} data-testid={`nav-${label}-link`}>{t(`nav.${label}`)}</NavLink>)}
      </nav>
      <a className="small-cta" href="mailto:sbf@gmail.com?subject=Logistics%20Inquiry" data-testid="header-contact-link">{t("nav.expert")} <ArrowRight size={15} /></a>
      <button className="menu" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-toggle" aria-label="Toggle navigation">{menuOpen ? <X size={25} /> : <Menu size={25} />}</button>
      {menuOpen && <nav className="mobile-nav" data-testid="mobile-navigation">
        {navItems.map(([label, href]) => <NavLink key={href} to={href} onClick={closeMenu} data-testid={`mobile-nav-${label}-link`}>{t(`nav.${label}`)}</NavLink>)}
        <a href="mailto:sbf@gmail.com?subject=Logistics%20Inquiry" onClick={closeMenu} data-testid="mobile-contact-link">{t("nav.expert")}</a>
      </nav>}
    </header>
    <Outlet />
    <footer data-testid="site-footer">
      <img src={assets.logo} alt="SBF" data-testid="footer-logo" />
      <span data-testid="footer-location">Balikpapan Selatan, Kalimantan Timur</span>
      <span data-testid="footer-copyright">© {new Date().getFullYear()} PT Samudera Berkah Firdaus.</span>
    </footer>
  </main>;
}